<template>
  <transition name="slide-fade">
    <default-layout>
      <v-app>
        <v-app-bar app clipped-left clipped-right elevate-on-scroll dark color="black" src="/images/myriam-zilles-KltoLK6Mk-g-unsplash.jpg" :bottom="$breakpoint.smAndDown">
          <template v-slot:img="{ props }">
            <v-img
              v-bind="props"
              gradient="to top right, rgba(19,84,22,.9), rgba(12,20,19,.8)"
            ></v-img>
          </template>
          <v-app-bar-nav-icon @click="drawer = !drawer" :class="drawer ? 'red--text' : ''"></v-app-bar-nav-icon>
          <v-toolbar-title role="button" @click.stop.prevent="goTo('/?redirect=' + route().current())" class="pl-0">
            <v-img src="/maskable_icon_x512.png" height="50px" width="50px"></v-img>
          </v-toolbar-title>
          <v-toolbar-items v-if="!$breakpoint.smAndDown">
            <v-btn small icon @click.stop.prevent="goTo('/?redirect=' + route().current())" :href="'/?redirect=' + route().current()">
              <v-icon>home</v-icon>
            </v-btn>
          </v-toolbar-items>
          <v-toolbar-items v-if="can['dashboard.view']">
            <v-btn :icon="$vuetify.breakpoint.xs" class="" text @click.stop.prevent="goTo('/dashboard')" href="/dashboard">
              <span v-if="$vuetify.breakpoint.xs">
                <v-icon>dashboard</v-icon>
              </span>
              <span v-else>Dashboard</span>
            </v-btn>
          </v-toolbar-items>
          <v-spacer></v-spacer>
          <v-toolbar-items v-show="$notifications.length > 0">
            <v-btn icon @click="messagesView = true;" title="Notifications">
              <v-badge :content="$notifications.length" :value="$notifications.length" color="green" overlap>
                <v-icon>
                  mdi-bell
                </v-icon>
              </v-badge>
            </v-btn>
          </v-toolbar-items>
          <v-toolbar-items>
            <v-btn icon fab text small v-if="getPrevious" @click="goTo(getPrevious)">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </v-toolbar-items>
          <v-toolbar-items>
            <v-btn @click.stop.prevent="reloadCurrent()" text small href="?reload=true" icon fab title="Reload current page">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-toolbar-items>
          <v-toolbar-items v-if="$breakpoint.smAndUp">
            <v-btn @click="_changeMode()" text small icon fab title="Toggle Dark Mode">
              <v-icon>mdi-theme-light-dark</v-icon>
            </v-btn>
          </v-toolbar-items>
          <v-toolbar-items>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn text small fab v-bind="attrs" v-on="on" title="Available Currencies">
                  {{ $currency }}
                </v-btn>
              </template>
              <v-list>
                <v-list-item link v-for="currency in $currencies" :key="currency.id" :title="currency.name" @click="_changeCurrency(currency, $currency != currency.code)" :inactive="currency.code === $currency">
                  <v-list-item-content>
                    <v-list-item-title>{{ currency.code }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-toolbar-items>
          <v-toolbar-items v-show="false">
            <v-btn @click="usermenu = !usermenu" text small icon fab title="User menu">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </v-toolbar-items>
          <v-toolbar-items>
            <v-menu bottom left offset-y  transition="fab-transition" :origin="$breakpoint.smAndDown ? 'bottom right' : 'top right'" :value="usermenu">
              <template v-slot:activator="{ on, attrs }">
                <v-btn fab v-bind="attrs" v-on="on" small title="User menu">
                  <v-avatar style="border: 1px solid;"><v-img :src="$user.profile_photo_url" lazy-src="/images/user.gif" alt="user profile photo"></v-img></v-avatar>
                </v-btn>
              </template>
              <user-menu></user-menu>
            </v-menu>
          </v-toolbar-items>
        </v-app-bar>
        <v-navigation-drawer :bottom="$breakpoint.xsOnly" v-model="drawer" app clipped>
          <v-list nav dense shaped>
            <v-list-item @click.native.stop.prevent="goTo('/dashboard')" href="/dashboard" v-show="can['dashboard.view'] && $breakpoint.xsOnly">
              <v-list-item-icon>
                <v-icon>mdi-view-dashboard</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Dashboard</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-spacer></v-spacer>
            <v-list-group :value="hideSettings" prepend-icon="mdi-format-list-bulleted-triangle">
              <template v-slot:activator>
                <v-list-item-title>Main Menu</v-list-item-title>
              </template>
              <inertia-link as="v-list-item" v-for="uri in mylinks" :key="uri.path" :href="uri.path" :title="uri.title" v-show="!uri.permission || can[uri.permission]" @click.stop="$breakpoint.smAndDown ? drawer = false : ''" link :class="route().current(uri.path.replace('/', '') + '.*') ? 'v-list-item--active' : ''">
                <v-list-item-icon>
                  <v-icon :color="uri.color == 'default' ? 'orange' : uri.color">{{ uri.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ uri.name }}</v-list-item-title>
                </v-list-item-content>
              </inertia-link>
            </v-list-group>
            <v-list-group :value="!hideSettings" prepend-icon="mdi-settings-outline">
              <template v-slot:activator>
                <v-list-item-title>Settings</v-list-item-title>
              </template>
              <inertia-link as="v-list-item" v-for="uri in settingslink" :key="uri.path" :href="uri.path" :title="uri.title" v-show="!uri.permission || can[uri.permission]" @click.stop="$breakpoint.smAndDown ? drawer = false : ''" link :class="route().current(uri.path.replace('/', '') + '.*') ? 'v-list-item--active' : ''">
                <v-list-item-content>
                  <v-list-item-title>{{ uri.name }}</v-list-item-title>
                  <v-list-item-subtitle>{{ uri.title }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-icon :color="uri.color == 'default' ? 'orange' : uri.color">{{ uri.icon }}</v-icon>
                </v-list-item-icon>
              </inertia-link>
              <inertia-link as="v-list-item" href="/settings" title="System settings" v-if="$admin">
                <v-list-item-icon>
                  <v-icon color="red">mdi-cogs</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>System Settings</v-list-item-title>
                </v-list-item-content>
              </inertia-link>
              <inertia-link as="v-list-item" href="/admin" title="Admin" v-if="$admin">
                <v-list-item-icon>
                  <v-icon color="red">security</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Admin</v-list-item-title>
                </v-list-item-content>
              </inertia-link>
            </v-list-group>
            <v-spacer></v-spacer>
            <inertia-link as="v-list-item" href="/reports" title="View Reports" v-if="can['reports.index']" class="primary--text">
              <v-list-item-icon>
                <v-icon color="red">mdi-chart-areaspline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Reports</v-list-item-title>
              </v-list-item-content>
            </inertia-link>
          </v-list>
          <template v-slot:append>
            <div class="pa-2 pull-right">
              <v-btn x-small href="/admin" fab v-if="$admin" title="Admin Dashboard" @click="goTo('/admin')" class="red--text" icon>
                <v-icon>security</v-icon>
              </v-btn>
              <v-btn @click="goTo('/reports')" x-small text icon fab title="Reports" class="primary--text" v-if="can['reports.index']">
                <v-icon>mdi-chart-areaspline</v-icon>
              </v-btn>
              <v-btn  x-small text @click="logout" class="red--text" :icon="$breakpoint.xsOnly" :fab="$breakpoint.xsOnly">
                <span v-if="!$breakpoint.xsOnly">Logout</span>
                <v-icon :right="!$breakpoint.xsOnly">mdi-logout</v-icon>
              </v-btn>
            </div>
          </template>
        </v-navigation-drawer>
        <v-navigation-drawer v-model="messagesView" app clipped right temporary :width="$notificationWidth">
          <user-notifications :notifications="$notifications"></user-notifications>
        </v-navigation-drawer>
        <v-main id="maincontent">
          <message-bar></message-bar>
          <transition name="slide-fade" mode="out-in">
            <slot></slot>
          </transition>
          <permission-for-notifications/>
        </v-main>
      </v-app>
    </default-layout>
  </transition>
</template>

<script>
import DefaultLayout from '@/Layouts/Default'
import PermissionForNotifications from '@/Mixins/PermissionForNotification'
import UserMenu from '@/Components/components/user-menu'
import Vue from 'vue'
import VueCookie from 'vue-cookie'
const MessageBar = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/messagebar.vue')
const UserNotifications = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/Notifications/notifications')

Vue.use(VueCookie)

  export default {
    name: 'main-layout',
    components: {
      PermissionForNotifications,
      UserMenu,
      DefaultLayout,
      MessageBar,
      UserNotifications,
    },
    metaInfo () {
      return {
        title: 'Dashboard'
      }
    },
    data () {
      return {
        drawer: false,
        messagesView: false,
        hideSettings: true,
        mylinks: [
          {
            name: 'Clients',
            title: 'Clients / Patients',
            path: '/clients',
            permission: 'clients.index',
            color: 'red',
            icon: 'mdi-account-group'
          },
          {
            name: 'Professionals',
            title: 'View Professionals',
            path: '/professionals',
            permission: 'professionals.index',
            color: 'default',
            icon: 'mdi-account-tie'
          },
          {
            name: 'Service Requests',
            title: 'View Requests',
            path: '/service_requests',
            permission: 'service_requests.index',
            color: 'default',
            icon: 'mdi-map-marker-plus-outline'
          },
          {
            name: 'Home-Based Healthcare',
            title: 'View Home-Based Healthcare',
            path: '/home-based-care',
            permission: 'home-based-care.index',
            color: 'blue',
            icon: 'mdi-home-thermometer-outline'
          },
          {
            name: 'Laboratory Requests',
            title: 'View Laboratory Test Requests',
            path: '/patient_tests',
            permission: null,
            color: 'red',
            icon: 'mdi-flask-outline'
          },
          {
            name: 'Pharmacy Requests',
            title: 'View Pharmacy Requests',
            path: '/pharmacy_requests',
            permission: null,
            color: 'red',
            icon: 'mdi-pill'
          },
          {
            name: 'TIKO Requests',
            title: 'View TIKO Requests',
            path: '/tiko_requests',
            permission: null,
            color: 'pink',
            icon: 'mdi-gender-female'
          },
          {
            name: 'Invoices',
            title: 'View invoices',
            path: '/invoices',
            permission: null,
            color: 'blue',
            icon: 'mdi-cash'
          },
          {
            name: 'Adverse Reactions',
            title: 'View adverse reactions',
            path: '/adverse_reactions',
            permission: null,
            color: 'blue',
            icon: 'mdi-heart-broken-outline'
          },
        ],
        usermenu: false,
        settingslink: [
          {
            name: 'Drugs Cabinet',
            title: 'View Available Drugs',
            path: '/drugs',
            permission: 'drugs.index',
            color: 'default',
            icon: 'mdi-pill'
          },
          {
            name: 'Lab Providers',
            title: 'View Laboratory Providers',
            path: '/laboratories',
            permission: 'laboratories.index',
            color: 'default',
            icon: 'mdi-flask-empty'
          },
          {
            name: 'Lab Tests',
            title: 'View Laboratory Tests',
            path: '/laboratory_tests',
            permission: 'labtests.index',
            color: 'default',
            icon: 'mdi-flask'
          },
          {
            name: 'Reg. Bodies',
            title: 'View Registration Bodies',
            path: '/registration_bodies',
            permission: 'regbodies.index',
            color: 'default',
            icon: 'mdi-folder'
          },
          {
            name: 'Professions',
            title: 'View Professions',
            path: '/professions',
            permission: 'professions.index',
            color: 'default',
            icon: 'mdi-clipboard-file'
          },
          {
            name: 'Insurance Providers',
            title: 'View Insurance Providers',
            path: '/insurance-providers',
            permission: 'packages.index',
            color: 'default',
            icon: 'mdi-umbrella'
          },
          {
            name: 'Pricing Packages',
            title: 'View Packages',
            path: '/packages',
            permission: 'packages.index',
            color: 'default',
            icon: 'mdi-package-variant'
          },
          {
            name: 'Currencies',
            title: 'View available currencies',
            path: '/currencies',
            permission: null,
            color: 'red',
            icon: 'mdi-cash-multiple'
          },
          {
            name: 'Diagnostic Kit',
            title: 'Set the minimum diagnostic kit',
            path: '/diagnostic_kits',
            permission: null,
            color: 'red',
            icon: 'mdi-stethoscope'
          },
          {
            name: 'Discount Coupons',
            title: 'View and create discount coupons',
            path: '/coupons',
            permission: 'coupons.index',
            color: 'red',
            icon: 'mdi-cash-minus'
          },
          {
            name: 'Service Items',
            title: 'Service items on homepage',
            path: '/serviceItems',
            permission: 'homepage.index',
            color: 'red',
            icon: 'mdi-grid'
          },
        ],
      }
    },
    methods: {
      logout () {
        this.$cookie.set('loggedout', true, { expires: '1D' })
        this.$inertia.post('/logout')
      },
      getprofile () {
        this.$inertia.visit('/user/profile')
      },
      goToLink (url) {
        this.$inertia.visit(url)
      },
      reloadCurrent () {
        this.$inertia.reload({ preserveScroll: true, preserveState: false })
      }
    },
    mounted () {
      this.$nextTick(() => {
        var cookie = this.$cookie.get('loggedout')
        if (cookie) {
          this.$cookie.delete('loggedout')
        }
      })
    },
  }
</script>

<style>
  .hidden {
    display: none;
  }
  [role="button"] {
    cursor: pointer;
  }
  @media screen and (min-width: 703px) {
    .v-dialog:not(.v-dialog--fullscreen) {
      max-width: 60vw;
    }
  }
  .v-dialog > .v-card > .v-card__text {
    padding: 1px;
  }
  .v-dialog {
    margin: 5px;
  }
  .v-card__title.primary {
    color: white;
  }
  .single-line {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
</style>
